import { IconButton, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";

type SearchFieldProps = TextFieldProps;

const SearchField: React.FC<SearchFieldProps> = (props) => {
  const { label, value, onChange, variant = "filled", sx, slotProps, ...rest } = props;

  return (
    <TextField
      label={label}
      variant={variant}
      value={value}
      onChange={onChange}
      sx={{ width: "100%", maxWidth: "30ch", ...sx }}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" hidden={!value}>
              <IconButton onClick={() => onChange?.({ target: { value: "" } } as any)} edge="end">
                <CancelIcon />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
      {...rest}
    />
  );
};

export default SearchField;
